import { render, staticRenderFns } from "./logoutSAML.vue?vue&type=template&id=0bab072e&scoped=true"
import script from "./logoutSAML.vue?vue&type=script&lang=js"
export * from "./logoutSAML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab072e",
  null
  
)

export default component.exports